import { Component, OnInit, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { IMenu } from '../../models/imenu.model';
import { AuthService } from "../../services/auth.service";
import { CurrentUserModel } from '../../models/account-ledger.model';
import { CommonService } from '../../services';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ApiResponse } from '../../models/api-response.model';
import { takeUntil } from 'rxjs/operators';


declare var jquery: any;
declare var $: any;

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {

  @Output() shrink = new EventEmitter<boolean>();

  private allMenus: IMenu[] = [];

  public loadingMenu: boolean = false;
  selectedMenuItem = "";
  collapseMenu: boolean = true;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  tourStep: string;
  hasFinanceQuote: boolean = true;
  currentUserModel: CurrentUserModel;

  @ViewChild('popoverSide') public popover: NgbPopover;
  @ViewChild('popoverAccount') public popoverAccount: NgbPopover;

  constructor(
    public authService: AuthService,
    private commonService: CommonService,
    private router: Router
  ) {
    this.commonService.set(NgbPopover.prototype, ['_unregisterListenersFn'], function () { });
  }

  ngOnInit() {
    this.loadingMenu = true;
    this.commonService.getHomeMenu().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: IMenu[]) => {

      this.allMenus = [ ...res ].map(m => {
        m.menuRouter = `/${m.menuId}`;
        m.menuIconPath = `../images/site-icons/${m.menuId}.svg`
        return m
      });

      //grouping menu sections
      this.authService.MENU_SECTION_1 = this.allMenus.filter(i => i.sectionId == 1);
      // move dashboard to the top
      this.authService.MENU_SECTION_1.findIndex(i => i.menuId === 'dashboard') > 0 && this.authService.MENU_SECTION_1.unshift(this.authService.MENU_SECTION_1.splice(this.authService.MENU_SECTION_1.findIndex(i => i.menuId === 'dashboard'), 1)[0]);

      this.authService.MENU_SECTION_2 = this.allMenus.filter(i => i.sectionId == 2);
      this.authService.MENU_SECTION_3 = this.allMenus.filter(i => i.sectionId == 3);
      this.authService.MENU_SECTION_4 = this.allMenus.filter(i => i.sectionId == 4);
      this.authService.menuLoadingCompleted = true;

      var collapseMenu = this.getCookie('collapseMenu');
      this.collapseMenu = collapseMenu != null ? collapseMenu == "true" : this.collapseMenu;
      this.tourStep = "";
      this.commonService.currentStep.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: string) => {
        this.tourStep = res;
        if (res && res == "step3") {
          this.popover.open();
        } else if (res && res == "step4") {
          this.popover.close();
          this.popoverAccount.open();
        } else if (res && res != "step4" && res != "step3") {
          if (this.popoverAccount.isOpen()) {
            this.popoverAccount.close();
          }
          if (this.popover.isOpen()) {
            this.popover.close();
          }
        }
      },
        (error: any) => {
          console.info(error);
        });
      this.authService
        .getLoginInfo()
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((res: CurrentUserModel) => {
  
        this.currentUserModel = res;
  
        if (this.currentUserModel.source !== 'SAP') {
          if (this.hasFinanceQuote) {
            this.commonService.hasFinanceQuote()
              .subscribe((result: ApiResponse) => {
                if (result && result.status == false) {
                  this.hasFinanceQuote = false;
                  this.authService.MENU_SECTION_1 = this.authService.MENU_SECTION_1.filter(i => i.menuId !== 'financing');
                }
              });
          }

          if (!res.isStaffAccount) {
            this.commonService
              .getLoggedInUserMenu()
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(res => {
                if (!res?.length) {
                  this.authService.MENU_SECTION_4 = this.authService.MENU_SECTION_4.filter(i => i.menuId !== 'admin');
                }
              });

              this.authService.MENU_SECTION_4 = this.authService.MENU_SECTION_4.filter(i => i.menuId !== 'kb');
          }

          if (!res.isStaffAccount || !res.isTestMode) {
            this.authService.MENU_SECTION_1 = this.authService.MENU_SECTION_1.filter(i => i.menuId !== 'quotes');
          }

          if(!res.isStaffAccount)
          {
            this.authService.MENU_SECTION_4 = this.authService.MENU_SECTION_4.filter(i => i.menuId !== 'windows-11-readiness');
          }

        } else if (this.currentUserModel.source === 'SAP') {
          //only show Search Products and Carts in Sidebar Menu
          this.authService.MENU_SECTION_1 = this.authService.MENU_SECTION_1.filter(i => ['search', 'carts'].includes(i.menuId));
        }
  
        if (this.currentUserModel.hideSOH) {
          this.authService.MENU_SECTION_1 = this.authService.MENU_SECTION_1.filter(i => i.menuId !== 'catalogues');
        }
   
        this.loadingMenu = false;
      });
   
      // if(!this.commonService.getIsDevOps())
      // {
      //   this.authService.MENU_SECTION_4 = this.authService.MENU_SECTION_4.filter(i => i.menuId !== 'windows-11-readiness');
      // }

      this.commonService.updateSideBarActiveItem$.subscribe(menuId => {
        this.selectedMenuItem = menuId;
      })
    });
  }

  shrinkEvent() {
    this.collapseMenu = !this.collapseMenu;
    this.shrink.emit(this.collapseMenu)
    this.createCookie(("collapseMenu=" + this.collapseMenu.toString()),30);
  }

  getCookie(name: string) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
    else return null;
  }

  createCookie(value: string, days: number) {
    var date = new Date();
    var expires = "";
    if (days) {
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toUTCString();
    }
    document.cookie = value+expires+"; path=/";
}

  navigateTo(item: IMenu): void {
    if (!this.tourStep) {
      this.router.navigateByUrl(item.menuRouter);
    }
  }

  previousTourStepTwo(): void {
    this.tourStep = "";
    this.commonService.monitorStepChange("step2");
  }

  previousTourStepThree(): void {
    this.tourStep = "step3";
    this.popoverAccount.close();
    this.commonService.monitorStepChange("step3");
  }

  nextTourStep(): void {
    this.commonService.monitorStepChange("step4");
  }

  nextTourStepAccount(): void {
    this.tourStep = "";
    this.commonService.monitorStepChange("step5");
  }

  routerToBuyComponent(linkTo: any) {
    //$('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    //this._router.navigateByUrl(linkTo);
    // }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
